<template>
  <CallScreen logo="onstar" title="OnStar" />
</template>

<script>
import CallScreen from "@/components/CallScreen";

export default {
  name: "Onstar",
  components: {
    CallScreen
  }
};
</script>

<style lang="scss" scoped></style>